import {Checkbox} from 'components/Checkbox';
import {TField} from 'core/types';

export const PrivateHouse: FC<TField> = ({className, value, ...inputProps}) => {
    return <Checkbox checked={Boolean(value)} className={className} isLabel label="Частный дом" {...inputProps} />;
};
